// Which item types a cover pile serves (phase 4 §5.9): films, series,
// books and video games (§4b.6; types made from those models). Small on purpose: the collection page
// reads it; the pile itself is loaded only on its page.

export const COVER_PRESETS = ['movie', 'tv', 'book', 'videogame'];

/** A game's box photo is kept with its item by default, first (§4b.6, decision 5): IGDB's cover is not the platform's. */
export const keepsPhotoByDefault = (type) => !!type && type.preset === 'videogame';

/** The collection's types a pile can fill, its default first. */
export const coverTypes = (inventory) => {
  const types = ((inventory && inventory.item_types) || []).filter(type => COVER_PRESETS.includes(type.preset));
  const preferred = inventory && inventory.default_item_type ? inventory.default_item_type.id : null;
  return [...types].sort((a, b) => Number(b.id === preferred) - Number(a.id === preferred));
};

/** The pile's address for a collection (a type, a batch). */
export const coversPath = (inventoryId, typeId, batchId) => {
  const params = [typeId ? `type=${typeId}` : null, batchId ? `batch=${batchId}` : null].filter(Boolean);
  return `/c/${inventoryId}/covers${params.length ? `?${params.join('&')}` : ''}`;
};
